import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Timesheets } from '@/features/timesheets'
import { requireActiveSubscription } from '@/lib/middleware'

const timesheetsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  memberId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  status: z.enum(['draft', 'submitted', 'approved', 'rejected', 'locked']).optional(),
  source: z.enum(['auto_generated', 'manual']).optional(),
  tab: z.enum(['approval', 'export', 'payruns', 'settings']).optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/timesheets/')({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: timesheetsSearchSchema,
  component: Timesheets,
})
